import React from 'react';
import {
  Clouds1a,
  Clouds1b,
  Clouds2a,
  Clouds2b,
} from './CloudAnimations.styled';

export const CloudAnimations = ({ playAnimation = true }) => {
  return (
    <React.Fragment>
      <Clouds1a $playAnimation={playAnimation} />
      <Clouds1b $playAnimation={playAnimation} />
      <Clouds2a $playAnimation={playAnimation} />
      <Clouds2b $playAnimation={playAnimation} />
    </React.Fragment>
  );
};
